import axios from 'axios'

const HTTP = axios.create({
  baseURL: '/api',
})

export default {
  async getTickets(retailId, pageSelected, ticketPerPage) {
    return await (
      await HTTP.get('tickets', {
        params: {
          retailId: retailId,
          pageSelected: pageSelected,
          ticketPerPage: ticketPerPage,
        },
      })
    ).data
  },
  async getQRCode(retailId) {
    return await (
      await HTTP.get('qrcode', { params: { retailId: retailId } })
    ).data
  },
  async sendQRCode(retailId, id, status, layout, price) {
    return await (
      await HTTP.post('qrcode', {
        id: new String(id),
        status: new String(status),
        price: new String(price),
        retailId: new String(retailId),
        layout: new String(layout),
      })
    ).data
  },
  async updateTicketStatus(retailId, id, status) {
    return await (
      await HTTP.patch(
        `selling/ticket/update/status/${encodeURIComponent(retailId)}/${encodeURIComponent(id)}/${encodeURIComponent(status)}`,
      )
    ).data
  },
  async reserveTicket(retailId, ticketId) {
    return await (
      await HTTP.post('reserve-ticket', { retailId, ticketId })
    ).data
  },
}
